import { api, urls } from "@aprosoja/api";

import { useSignUpContext } from "@/app/screens/sign-up/context/sign-up.context";
import { PaymentStepFormValues } from "./schema";

const usePayment = () => {
  const { signUpReducer, setSignUpReducer } = useSignUpContext();

  const onSubmit = async (values: PaymentStepFormValues) => {
    if (signUpReducer?.createdUserData?.id) {
      try {
        const userPaymentResponse = await api.post(urls.customersCheckout, {
          userId: signUpReducer.createdUserData.id,
          paymentMethod: values.paymentType,
          creditCard:
            values.paymentType === "CREDIT_CARD"
              ? {
                  holderName: values.holderName,
                  number: values.number,
                  ccv: values.ccv,
                  expiryMonth: values.expiringDate?.slice(0, 2),
                  expiryYear: values.expiringDate?.slice(2, 4),
                }
              : undefined,
        });

        if (
          userPaymentResponse.status === 200 ||
          userPaymentResponse.status === 201
        ) {
          setSignUpReducer({
            type: "paymentSucceeded",
            paymentSucceededPayload: true,
          });
          if (values.paymentType === "CREDIT_CARD") {
            setSignUpReducer({ type: "signUpStep", signUpStepPayload: 5 });
          }
          if (values.paymentType === "PIX") {
            setSignUpReducer({
              type: "pixOrBankSlipInfo",
              pixOrBankSlipInfoPayload: userPaymentResponse.data,
            });
            setSignUpReducer({ type: "signUpStep", signUpStepPayload: 3 });
          }
          if (values.paymentType === "BOLETO") {
            setSignUpReducer({
              type: "pixOrBankSlipInfo",
              pixOrBankSlipInfoPayload: userPaymentResponse.data,
            });
            setSignUpReducer({ type: "signUpStep", signUpStepPayload: 4 });
          }
        }
      } catch (err) {
        setSignUpReducer({
          type: "paymentSucceeded",
          paymentSucceededPayload: false,
        });
        setSignUpReducer({ type: "signUpStep", signUpStepPayload: 5 });
      }
    }
  };

  return { onSubmit };
};

export default usePayment;
